import React from "react";

const medalIcon: string = require("../../assets/images/medal-icon.svg").default;

interface ExperienceLabelProps {
	experience: string | undefined;
}

const ExperienceLabel = ({ experience }: ExperienceLabelProps) => {

  return (<div className="experience-label d-flex">
    <img src={medalIcon} alt='medal-icon' className="medal-icon" />
    <div className="experience ms-2">{experience}</div>
  </div>);
}


export default ExperienceLabel;